/**
 * @namespace Stores
 * @category Stores
 * @module box-store
 * */

import {
  getBoxSensorAssigments,
  getVehicleBoxAllocations,
} from '@/services/box-service.js'

export default {
  namespaced: true,
  state: {
    boxVehicleAllocations: [],
    boxAvailable: [],
    boxConfigurations: [],
    boxAssignments: [],
    isTest: false,
  },
  getters: {
    /**
     * Used by Diagnostics module to filter/normalize ANA with related boxAssignment item
     * @param {*} state
     * @param {*} getters
     * @returns
     */
    boxAssignmentForSensor:
      (state, getters) => (sensorType, number, boxNumber, vehicleId) => {
        let assignmentItems = getters['boxAssignmentsByBoxNumber'](boxNumber)
        return assignmentItems.find(
          (assignmentItem) =>
            assignmentItem.sensor.sensorType == sensorType &&
            assignmentItem.sensor.number == number
        )
      },
    /**
     * Used by Diagnostics module to filter/normalize ANA with related boxAssignment item
     * @param {*} state
     * @returns
     */
    boxAssignmentsByBoxNumber: (state) => (boxNumber) => {
      if (state.isTest) {
        state.boxVehicleAllocations[0].boxNumber = boxNumber
      }

      let boxAllocation =
        state.boxVehicleAllocations.find(
          (item) => item.boxNumber.toString() == boxNumber.toString()
        ) || state.boxVehicleAllocations[0]
      if (!boxAllocation) {
        console.warn({
          details: 'It could not find box allocation',
          boxVehicleAllocations: state.boxVehicleAllocations
            .map((bva) => bva.boxNumber)
            .join(),
          boxNumber,
        })
        return null
      }
      let boxConfigId = parseInt(
        boxAllocation.boxConfiguration.split('/').pop()
      )
      let items = state.boxAssignments.filter(
        (boxAssignment) => (boxAssignment.boxConfigId = boxConfigId)
      )
      return items
    },
  },
  mutations: {},
  actions: {
    /**
     * Used by Diagnostics module to filter/normalize ANA with related boxAssignment item
     */
    async updateConfigurations({ state }, { vehicleId }) {
      state.boxVehicleAllocations = await getVehicleBoxAllocations([vehicleId])

      state.boxAssignments = (
        await Promise.all(
          state.boxVehicleAllocations.map((item) => {
            return (async () => {
              let boxConfigAssigments = await getBoxSensorAssigments(
                item.boxConfigId
              )
              return boxConfigAssigments.map((assignmentItem) => {
                assignmentItem.boxConfigId = item.boxConfigId
                return assignmentItem
              })
            })()
          })
        )
      ).reduce((acc, array) => {
        return [...acc, ...array]
      }, [])
    },
  },
}
